export default __webpack_public_path__ + "static/media/deep-thoughts.2036fa24.jpg";